<template>
	<div class="content">
    <base-header class="pb-6">
	<div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.info") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
				<route-breadcrumb />
			</nav>
        </div>

       
      </div>
	</base-header>

	<div class="container-fluid mt--6">
  <card>
    <div slot="header" class="row align-items-center">
      <div class="col-8">
        <h3 class="mb-0">Edit profile </h3>
      </div>
    </div>

	<validation-observer ref="formValidator">
    <form @submit.prevent="updateProfile">
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('fname')"
              :name="$t('fname')"
              v-model="params.fname"
            >
            </base-input>
          </div>
		</div>
		<div class="row">
			<div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('lname')"
              :name="$t('lname')"
              v-model="params.lname"
            >
            </base-input>
          </div>
        </div>
		<div class="row">
			<div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('nick_name')"
              :name="$t('nick_name')"
              v-model="params.nick_name"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="text"
			  rules="required|numeric"
              :label="$t('phone')"
              :name="$t('phone')"
              v-model="params.phone"
            >
            </base-input>
          </div>
        </div>

		<div class="row">
		  <div class="col-lg-6">
			<base-button
			  type="primary"
			  size="md"
			  @click="updateProfile"
			  >Save</base-button>
		  </div>
		</div>
	  </div>


     

    </form>
	</validation-observer>
  </card>

  <!--
    LINE account link (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §5).

    The whole card disappears once the API has told us the feature is off
    (503 errors.auth.line_disabled — `bo_line.enabled=false`, or the migration
    in §3 has not been run yet): showing a button that can only fail is worse
    than showing nothing. Until then it renders, because §2's contract has no
    "is it enabled" field to probe and probing the authorize-url on every page
    load would mint a throwaway state in Redis and eat the per-IP cap.
  -->
  <card v-if="!lineDisabled" class="mt-4">
    <div slot="header" class="row align-items-center">
      <div class="col-8">
        <h3 class="mb-0">{{ $t("profile.line_title") }}</h3>
      </div>
    </div>

    <div class="pl-lg-4">
      <!-- Linked -->
      <div v-if="isLineLinked" class="d-flex align-items-center flex-wrap">
        <!-- The avatar is hosted by LINE and can 404 once the user changes it;
             @error drops it so the row does not show a broken-image glyph. -->
        <img
          v-if="lineLink.line_picture_url && !lineAvatarBroken"
          :src="lineLink.line_picture_url"
          :alt="lineLink.line_display_name"
          class="line-card__avatar mr-3"
          @error="lineAvatarBroken = true"
        />
        <span v-else class="line-card__avatar line-card__avatar--empty mr-3" aria-hidden="true"></span>

        <div class="mr-auto">
          <div class="line-card__name">
            {{ lineLink.line_display_name || $t("profile.line_linked") }}
          </div>
          <small v-if="lineLink.line_linked_at" class="text-muted">
            {{ $t("profile.line_linked_at") }} {{ lineLinkedAtText }}
          </small>
        </div>

        <base-button
          type="danger"
          outline
          size="sm"
          :disabled="lineBusy"
          @click="unlinkLine"
          >{{ $t("profile.line_unlink") }}</base-button
        >
      </div>

      <!-- Not linked -->
      <div v-else>
        <p class="text-muted mb-3">{{ $t("profile.line_not_linked") }}</p>
        <button
          type="button"
          class="btn btn-line"
          :disabled="lineBusy"
          @click="connectLine"
        >
          <!-- Inline SVG rather than `fab fa-line`: FontAwesome arrives from a
               CDN <link> (public/index.html:30). -->
          <svg
            class="btn-line__icon"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="currentColor"
              d="M12 2C6.486 2 2 5.63 2 10.09c0 3.998 3.56 7.345 8.37 7.977.325.07.768.215.88.494.1.251.066.645.032.9l-.142.86c-.043.254-.202 1 .88.545 1.083-.455 5.843-3.44 7.976-5.89C21.33 13.26 22 11.74 22 10.09 22 5.63 17.514 2 12 2Z"
            />
            <path
              :fill="lineBrandColor"
              d="M6.3 7.8H7.08V11.42H8.9V12.2H6.3ZM9.7 7.8H10.45V12.2H9.7ZM11.25 7.8H12.03L13.47 10.6V7.8H14.25V12.2H13.47L12.03 9.4V12.2H11.25ZM15.05 7.8H17.65V8.58H15.83V9.61H17.65V10.39H15.83V11.42H17.65V12.2H15.05Z"
            />
          </svg>
          <span class="btn-line__label">{{ $t("profile.line_connect") }}</span>
        </button>
      </div>
    </div>
  </card>
  </div>
  </div>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import BaseButton from '../../components/BaseButton.vue';
import swal from 'sweetalert2';
import {
	LINE_BRAND_COLOR,
	LINE_PURPOSE_LINK,
	lineErrorKeyFromError,
	lineIsDisabled,
	rememberLinePurpose
} from '@/utils/boLine';
export default {
  components: { BaseButton },
  data() {
    return {
	  // LINE link card (spec 2026-10-03 §5).
	  // lineDisabled starts false and only ever turns true after the API has
	  // actually answered 503: there is no "enabled" flag in the §2 contract to
	  // read up front, and probing the authorize-url on mount would mint a
	  // throwaway `state` in Redis on every visit to this page.
	  lineDisabled: false,
	  lineBusy: false,
	  lineAvatarBroken: false,
	  lineBrandColor: LINE_BRAND_COLOR,
      params: {
		fname : "",
		lname : "",
		email : "",
		phone : "",
		address : "",
		district_id : "",
		city_id : "",
		province_id : "",
		zipcode : "",
		nick_name:"",
		}
    };
  },
  computed:{
	...mapGetters({
		Profile: 'Auth/getUser',
		lineLink: 'Auth/getLineLink',
		isLineLinked: 'Auth/isLineLinked',
	}),

	// "เชื่อมต่อเมื่อ <วันเวลา>". moment is how the rest of this repo formats a
	// timestamp for display (e.g. PlatformStatementList.vue:410); an unparseable
	// value renders as nothing rather than "Invalid date".
	lineLinkedAtText() {
		const raw = this.lineLink.line_linked_at;
		if (!raw) return '';
		const m = moment(raw);
		return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '';
	}

  },
  mounted(){
	this.params.fname = this.Profile.fname;
	this.params.lname = this.Profile.lname;
	this.params.email = this.Profile.email;
	this.params.phone = this.Profile.phone;
	this.params.nick_name = this.Profile.nick_name;
	// The login response does NOT carry the LINE columns (spec §2 #2 answers the
	// plain LoginResponse); only GET /api/v1/profile does (#6). Without this
	// fetch the card would claim "ยังไม่ได้เชื่อมต่อ" to someone who is linked.
	this.loadLineStatus();
	// this.params.address = this.Profile.address;
	// this.params.district_id = this.Profile.district_id;
	// this.params.city_id = this.Profile.city_id;
	// this.params.province_id = this.Profile.province_id;
	// this.params.zipcode = this.Profile.zipcode;
  },
  methods: {
	...mapActions({
		changeProfile: 'Auth/changeProfile',
		changePassword:'Auth/changePassword',
		getProfile:'Auth/getProfile',
		setProfile:'Auth/setProfile',
		lineProfileAuthorizeUrl: 'Auth/lineProfileAuthorizeUrl',
		lineUnlink: 'Auth/lineUnlink'
	}),

	// --- LINE link card (spec 2026-10-03 §1 "Link", §5) -------------------

	loadLineStatus() {
		this.getProfile().then((resp) => {
			if (resp && resp.data && resp.data.Datum) {
				this.setProfile(resp.data.Datum);
			}
			this.lineAvatarBroken = false;
		}).catch((err) => {
			// Already-mounted profile data stays on screen; only the LINE card
			// is hidden, and only when the API said the feature is off.
			if (lineIsDisabled(err)) this.lineDisabled = true;
		});
	},

	// Step 2-3 of the link flow. The BE mints `state` + `nonce` and binds the
	// state to this JWT's user id; nothing here may invent or inspect either
	// (spec §1 "Security invariants").
	connectLine() {
		if (this.lineBusy) return;
		this.lineBusy = true;
		this.lineProfileAuthorizeUrl().then((resp) => {
			const url = resp && resp.data && resp.data.url;
			if (!url) {
				this.lineBusy = false;
				swal.fire({
					title: this.$t('errors.auth.line_verify_failed'),
					icon: 'error',
					confirmButtonText: 'OK'
				});
				return;
			}
			rememberLinePurpose(LINE_PURPOSE_LINK);
			window.location.href = url;
		}).catch((err) => {
			this.lineBusy = false;
			if (lineIsDisabled(err)) {
				// §5: hide the card rather than leave a button that only fails.
				// The message still appears once, so the staff member knows the
				// card vanished because the feature is not switched on yet and
				// not because the page is broken.
				this.lineDisabled = true;
				swal.fire({
					title: this.$t('profile.line_disabled'),
					icon: 'info',
					confirmButtonText: 'OK'
				});
				return;
			}
			swal.fire({
				title: this.$t(lineErrorKeyFromError(err)),
				icon: 'error',
				confirmButtonText: 'OK'
			});
		});
	},

	unlinkLine() {
		if (this.lineBusy) return;
		swal.fire({
			title: this.$t('profile.line_unlink'),
			text: this.$t('profile.line_unlink_confirm'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: this.$t('profile.line_unlink'),
			cancelButtonText: this.$t('cancel'),
			confirmButtonClass: 'btn btn-danger btn-fill',
			cancelButtonClass: 'btn btn-default btn-fill',
			buttonsStyling: false
		}).then((result) => {
			if (!result.value) return;
			this.lineBusy = true;
			this.lineUnlink().then(() => {
				this.lineBusy = false;
				this.lineAvatarBroken = false;
				swal.fire({
					title: this.$t('profile.line_unlink_success'),
					icon: 'success',
					confirmButtonText: 'OK'
				});
			}).catch((err) => {
				this.lineBusy = false;
				if (lineIsDisabled(err)) {
					this.lineDisabled = true;
					return;
				}
				swal.fire({
					title: this.$t(lineErrorKeyFromError(err)),
					icon: 'error',
					confirmButtonText: 'OK'
				});
			});
		});
	},

    updateProfile() {
		if (this.$refs.formValidator.validate()) {
			this.changeProfile(this.params).then((resp) => {
				swal.fire({
					title: 'Success',
					text: 'Profile has been updated',
					icon: 'success',
					confirmButtonText: 'OK'
				});

				this.getProfile().then((resp) => {
					console.log(resp)
					this.setProfile(resp.data.Datum);
				}).catch((err) => {
					console.log(err);
				})


				// this.$router.push({ name: 'BOOrders' });
			}).catch((err)=>{
				swal.fire({
					title: 'Error',
					text: err,
					icon: 'error',
					confirmButtonText: 'OK'
				});
			});
		}
    }
  }
};
</script>
<style scoped>
/* LINE link card (spec 2026-10-03 §5): 48px circular avatar. */
.line-card__avatar {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	object-fit: cover;
	/* A 1px ring so a white/very light LINE avatar still reads as a disc on the
	   card's white background. */
	box-shadow: 0 0 0 1px #dee2e6;
}

.line-card__avatar--empty {
	display: inline-block;
	background-color: #e9ecef;
}

.line-card__name {
	font-weight: 600;
}

/* LINE's brand green is fixed by their guidelines, so it is not an Argon theme
   colour and does not go through btn-*. Mirrors Login.vue's .btn-line. */
.btn-line {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: #06c755;
	border-color: #06c755;
	color: #fff;
	font-weight: 600;
}

.btn-line:hover,
.btn-line:focus {
	background-color: #05b14c;
	border-color: #05b14c;
	color: #fff;
}

.btn-line:focus {
	box-shadow: 0 0 0 3px rgba(6, 199, 85, 0.45);
	outline: none;
}

.btn-line:disabled,
.btn-line[disabled] {
	opacity: 0.65;
	cursor: not-allowed;
}

.btn-line__icon {
	flex: 0 0 auto;
	margin-right: 0.5rem;
}

.btn-line__label {
	line-height: 1.2;
}
</style>
